module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#sec1"
    }
  }, [_vm._v("Seven Years to Financial Independence")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#sec2"
    }
  }, [_vm._v("How long are you willing to wait to get Rich?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#sec3"
    }
  }, [_vm._v("This Book is not just for Baby Boomers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#sec4"
    }
  }, [_vm._v("Introducing the Seven Years to Seven Figures Program")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01"
    }
  }, [_vm._v("Part I: Seven Years to Seven Figures: Is it Really Possible?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Chapter 1: What the Heck do I know?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec1"
    }
  }, [_vm._v("How to make Decisions that Stick")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec2"
    }
  }, [_vm._v("Anatomy of a Really Big Raise")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec3"
    }
  }, [_vm._v("Don’t be afraid of your Underlings")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec4"
    }
  }, [_vm._v("Becoming a Chicken Entrepreneur")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec5"
    }
  }, [_vm._v("But that was just the Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("Chapter 2: Are you Ready for Wealth?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec1"
    }
  }, [_vm._v("Perry Wagner")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec2"
    }
  }, [_vm._v("John Newman")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec3"
    }
  }, [_vm._v("Take your First Step toward Financial Independence . . . Right now")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec4"
    }
  }, [_vm._v("When it comes to Wealth, How Much is enough?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec5"
    }
  }, [_vm._v("Four Levels of Seven-Figure Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec6"
    }
  }, [_vm._v("Coping with a Mere Million")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec7"
    }
  }, [_vm._v("The $2.5 Million Lifestyle")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec8"
    }
  }, [_vm._v("The Next Level: Living on a $5.5 Million Nest Egg")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec9"
    }
  }, [_vm._v("The Ultimate Lifestyle")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec10"
    }
  }, [_vm._v("But what if you can’t Possibly Save $335,000 a Year?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec11"
    }
  }, [_vm._v("How much of your Income should you be Saving?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Eight Stories, Eight Successes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Audrey Maxwell: How a Good Employee can Become a Great Partner, Build a Dream House, and Become a Millionaire in Seven Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Million-Dollar Career")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When your Support Net Disappears")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Follow Audrey’s Path to Seven Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to get your Boss to give you Equity in the Business")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transitioning from “Valuable” to “Invaluable”")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First and Most Important Secret to getting what you want")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anatomy of a Great Self-Promotion Presentation")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reinventing the Price of your Company’s Product to Boost Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Establishing the All-Important Back End")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making a Wealth-Wise Decision about your Home")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Make your Money by Buying Right")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sniffing Out the Best Real Estate Deals")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Audrey’s Future")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Alan Silver: Converting Selling Skills into Millions of Dollars of Equity in Five Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Payoff")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making the Big Leap—Running your Own Business, Full-Time")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downsizing the Company, Upgrading the Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Differentiating Yourself from the Competition")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wise Decisions of a Wealth Builder")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Alan Became a Multimillionaire in Less than Five Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asking for Help")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riding on Coattails")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding the Golden Key to your Future Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mastering the Mega-Power of the Back End")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treat Your Superstars Right")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Bruce Buffer: Giving up a Six-Figure Income to Generate a Seven-Figure Net Worth")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Profits Lead to Easy Spending")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recognizing the Potential for Colossal Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expanding the Money-Making Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Million-Dollar Lifestyle")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secrets of Bruce’s Success")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s Next for Bruce?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How you can Follow Bruce’s Path to Success")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Justin Ford: Achieving a Radical Financial Transformation—How to go from Bankruptcy to Millionaire in Six Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Tough Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asking for—and Ignoring—Good Advice")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Falling off the Horse . . . And Finding the Courage to Climb Back on")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building Skills, Experience, and Income")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Financial Security—and then Some")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becoming an Entrepreneur for the Second Time in Five Years—but Doing it Right this Time")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Your Money to Work for You")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Becoming an Expert in yet another Field")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking Real Estate to the Next Level")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Automatic Money Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What you can learn from Justin’s Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What does the Future Hold for Justin?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Ken Morris: Coming to America and Cashing In on the American Dream—From $10,000 to $10,000,000")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Branching Out Leads to . . . More Money")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where the Real Wealth Comes From")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Projects Mean Big Profits")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combining Two Winning Strategies")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five Elements of Ken’s Success")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Monica Day: Getting Started—how to Boost your Income from $26,000 to $134,000 in Two Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Help in the Form of a Long-Forgotten Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monica Lands her First Client")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Six-Figure Income . . . In Only Two Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road to Seven Figures in Seven Years as a Copywriter")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If you decide to become a Copywriter, Here’s what you need to Know")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Companies that Need Copywriters")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preaching to the Copywriting-Friendly Choir")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gathering Samples and Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using your Current Career to Boost your Copywriting Career")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Establishing your Fees")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Developing a Network of Peers and Mentors")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copywriting Masters Reveal How It’s Done")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monica’s Bright Future in Copywriting")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: David Keller: You Don’t Need a Medical Degree to make a Million Dollars")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David’s First Opportunity Practically Fell in his Lap")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He had to Work a Little Harder to Create a Second Opportunity for Himself")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Money Starts Rolling In")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David Educates Himself for Success")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Focus on Selling the Service . . . And Profits Will Follow")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Help from an Unlikely Source")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David’s Workday—Then and Now")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What you can learn From David’s Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding a Good Mentor . . . And then Paying your Mentor Back")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding that Cooperation is Usually Better than Competition")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Marketing your Primary Business Skill")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saving as Much as you can")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Brad Solomon: Even Accountants Can Get Rich—how to Hit $4 Million in Six Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brad’s First Year in Business")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beginnings of a Strong Support Network")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Gradual Increase in Skills, Clients . . . And Profits")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Direct Marketing to Stimulate Business Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Focusing on Customer Satisfaction")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating a Second Stream of Income")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building a Portfolio of Assets")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("$2 Million Richer . . . without Doing a Thing")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking Back")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking to the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Replicate Brad’s Success")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing the Business Sector That’s Best for you")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Find (And Take Advantage of) a Great Mentor")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Find Your Mentor")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Prove Yourself in the Marketplace")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Grow your Rolodex")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Partners and Superstars—How to Find and Work with the Right People")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Develop a Second Stream of Income")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shooting for an Extra $25,000 a Year is a Good—and Reasonable—Place to Start")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Way to Create a Second Income is to start a Part-Time Local Service Business")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Started in the Service Business—Right Away")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Why you Must Act Now")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Baby Boomer Challenge: Why 50- and 60-Year-Olds Must Follow the Seven Years to Seven Figures Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worried about Retirement? You are not Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What about the American Economy?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Lessons from Life: What I’ve learned about Building Wealth Quickly")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starting with a Tabula Rasa")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lifestyle you have always dreamed of . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 57
// module chunks = 0